var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 407 413",
    style: {
      enableBackground: "new 0 0 407 413"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;enable-background:new; opacity: 0.6}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.2,320.6L252.7,205.7L367.5,92.3c4.7-4.7,4.7-12.4,0-17.1l-32.6-32.8c-2.3-2.3-5.3-3.5-8.5-3.5 s-6.3,1.3-8.5,3.5L203.5,155.5L89.2,42.5c-2.3-2.3-5.3-3.5-8.5-3.5s-6.3,1.3-8.5,3.5L39.5,75.3c-4.7,4.7-4.7,12.4,0,17.1 l114.7,113.4L39.9,320.6c-2.3,2.3-3.6,5.3-3.6,8.5s1.2,6.3,3.6,8.5l32.6,32.8c2.4,2.4,5.4,3.6,8.5,3.6s6.2-1.1,8.5-3.6l113.9-114.5 l114,114.4c2.4,2.4,5.4,3.6,8.5,3.6s6.2-1.1,8.5-3.6l32.6-32.8c2.3-2.3,3.6-5.3,3.6-8.5C370.8,325.9,369.5,322.9,367.2,320.6 L367.2,320.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.4d3279a113b6adb5dc5f3af77165a143.svg";
export { ForwardRef as ReactComponent };